/**
 * Eén plek voor meldingen in de console. Straks kan hier een foutmelder
 * (bijv. Sentry) op aangesloten worden zonder dat componenten veranderen.
 */
type Scope = 'catalogus' | 'account' | 'marketing' | 'pagina' | 'winkelmand' | 'kassa'

const tag = (scope: Scope) => `[${scope}]`

export const log = {
  /** Iets klopt niet in de data, maar de site werkt door. */
  warn(scope: Scope, message: string, details?: string[]) {
    if (typeof console === 'undefined') return
    console.warn(`${tag(scope)} ${message}${details?.length ? `\n${details.join('\n')}` : ''}`)
  },
  /** Een onverwachte fout (bijv. uit een foutgrens). */
  error(scope: Scope, error: unknown, componentStack?: string | null) {
    if (typeof console === 'undefined') return
    if (componentStack) console.error(tag(scope), error, componentStack)
    else console.error(tag(scope), error)
  },
}
